import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormBuilder, Validators, ReactiveFormsModule, FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import { ImageBannerComponent } from "../../components/image-banner/image-banner.component";
import { ProjectCirclesComponent } from "../../includes/project-circles/project-circles.component";
import { ContactForm, ContactFormType } from '../../../../models/contact-form';
import { ApiService } from '../../services/api.service';
import { SpinnerComponent } from "../../includes/spinner/spinner.component";
import { MetaService } from '../../services/meta.service';

@Component({
  selector: 'pc-contact-us',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ImageBannerComponent,
    ProjectCirclesComponent,
    NgClass,
    SpinnerComponent
],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {
  // Banner Image
  bannerImgUrl: string | undefined;

  showGeneralContact: boolean | undefined;
  showBidRequestContact: boolean | undefined;
  showCareerContact: boolean | undefined;
  
  submitting: boolean | undefined;
  showFeedbeck: boolean | undefined;
  isSuccessful: boolean | undefined;
  isFailure: boolean | undefined;

  constructor(
    private router: Router,
    private metaService: MetaService,
    private route: ActivatedRoute, 
    private fb: FormBuilder, 
    private apiService: ApiService,
  ) { }

  contactUsForm = this.fb.group({
    hpName: [''], // honeypot field
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required, this.formattedPhoneValidator()]],
    message: ['', [Validators.required]],
  });

  bidRequestForm = this.fb.group({
    hpName: [''], // honeypot field
    companySponsor: ['', [Validators.required]],
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    address1: ['', [Validators.required]],
    address2: ['', []],
    city: ['', [Validators.required]],
    state: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required, this.formattedPhoneValidator()]],
    fax: ['', []],
    jobName: ['', [Validators.required]],
    jobType: ['', [Validators.required]],
    jobLocation: ['', [Validators.required]],
    jobEstBudget: ['', [Validators.required]],
    jobStartDate: ['', [Validators.required]],
    jobDuration: ['', [Validators.required]],
    file: [''],
    message: ['', []]
  });

  careersForm = this.fb.group({
    hpName: [''], // honeypot field
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    address1: ['', [Validators.required]],
    address2: ['', []],
    city: ['', [Validators.required]],
    state: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required, this.formattedPhoneValidator()]],
    position: ['', [Validators.required]],
    file: ['', [Validators.required]],
  });

  stateList: any = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  ngOnInit(): void {
    this.metaService.setMetadata('contact-us');

    // Make sure we're at top of page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });

    this.submitting = false;
    this.isSuccessful = false;
    this.isFailure = false;

    this.determineFormToShow();
    
    // Banner Image
    this.bannerImgUrl = 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/contact/banner';
  }

  determineFormToShow(): void {
    // Determine which form to show based on route fragment
    this.route.fragment.subscribe(fragment => {
      this.showGeneralContact = (fragment != 'bid-request' && fragment != 'careers') ? true : false;
      this.showCareerContact = fragment == 'careers' ? true : false;
      this.showBidRequestContact = fragment == 'bid-request' ? true : false;
    });
  }

  showGeneralContactForm(): void {
    this.showGeneralContact = true;
    this.showBidRequestContact = false;
    this.showCareerContact = false;

    setTimeout(() => {
      const el = document.getElementById('generalContactForm');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Fallback for mobile
        const rect = el.getBoundingClientRect();
        window.scrollTo({ top: window.scrollY + rect.top - 120, behavior: 'smooth' });
      }
    }, 100);
  }
  showBidRequestContactForm(): void {
    this.showGeneralContact = false;
    this.showBidRequestContact = true;
    this.showCareerContact = false;

    setTimeout(() => {
      const el = document.getElementById('bidRequestForm');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Fallback for mobile
        const rect = el.getBoundingClientRect();
        window.scrollTo({ top: window.scrollY + rect.top - 120, behavior: 'smooth' });
      }
    }, 100);
  }
  showCareersContactForm(): void {
    this.showGeneralContact = false;
    this.showBidRequestContact = false;
    this.showCareerContact = true;

    setTimeout(() => {
      const el = document.getElementById('careersForm');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Fallback for mobile
        const rect = el.getBoundingClientRect();
        window.scrollTo({ top: window.scrollY + rect.top - 120, behavior: 'smooth' });
      }
    }, 100);
  }

  onBidRequestFormFileChange(event: any) {
    let reader = new FileReader();
   
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.bidRequestForm.patchValue({
          file: reader.result ? reader.result.toString() : ''
        });
      };
    }
  }

  onCareersFormFileChange(event: any) {
    let reader = new FileReader();
   
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.careersForm.patchValue({
          file: reader.result ? reader.result.toString() : ''
        });
      };
    }
  }

mapFormGroupToContactForm(form: FormGroup, type: ContactFormType): ContactForm {
  const raw = form.value || {};
  const { file, hpName, ...fields } = raw;

  const contactForm: ContactForm = {
    type,
    hpName,
    fields: fields as Record<string, string>
  };

  // only add file if it's actually defined and non-empty
  if (file && typeof file === 'string' && file.trim().length > 0) {
    contactForm.file = file;
  }

  return contactForm;
}

  onSubmit(formType: string): void {
    this.submitting = true;

    let formGroup: FormGroup | null = null;
    let formData: ContactForm | undefined;

    switch (formType) {
      case 'contactUsForm':
        formGroup = this.contactUsForm;
        formData = this.mapFormGroupToContactForm(formGroup, ContactFormType.Contact);
        break;
      case 'bidRequestForm':
        formGroup = this.bidRequestForm;
        formData = this.mapFormGroupToContactForm(formGroup, ContactFormType.BidRequest);
        break;
      case 'careersForm':
        formGroup = this.careersForm;
        formData = this.mapFormGroupToContactForm(formGroup, ContactFormType.Careers);
        break;
    }

    if (!formGroup || !formData) {
      this.submitting = false;
      return;
    }

    this.apiService.mail(formData).subscribe({
      next: () => {
        this.isSuccessful = true;
        this.isFailure = false;
        this.submitting = false;
        this.showFeedbeck = true;

        formGroup.reset();
        formGroup.markAsPristine();
        formGroup.markAsUntouched();

        // clear the file inputs
        if (formType === 'bidRequestForm') {
          this.clearFileInput('bidFile');
          this.bidRequestForm.patchValue({ file: '' });
        }
        if (formType === 'careersForm') {
          this.clearFileInput('careerFile');
          this.careersForm.patchValue({ file: '' });
        }

        setTimeout(() => (this.showFeedbeck = false), 5000);
      },
      error: (err) => {
        this.isFailure = true;
        this.isSuccessful = false;
        this.submitting = false;
        this.showFeedbeck = true;

        setTimeout(() => (this.showFeedbeck = false), 5000);
      },
    });
  }

  // Error / validation logic
  get generalFormControls(): any {
    return this.contactUsForm['controls'];
  }
  get bidFormControls(): any {
    return this.bidRequestForm['controls'];
  }
  get careersFormControls(): any {
    return this.careersForm['controls'];
  }
  generalFormHasError(field: string): boolean {
    return ( (!this.contactUsForm.get(field)?.valid && !this.contactUsForm.get(field)?.pristine) || false );
  }
  bidFormHasError(field: string): boolean {
    return ( (!this.bidRequestForm.get(field)?.valid && !this.bidRequestForm.get(field)?.pristine) || false );
  }
  careerFormHasError(field: string): boolean {
    return ( (!this.careersForm.get(field)?.valid && !this.careersForm.get(field)?.pristine) || false );
  }

  errorMessage(error: any): string {
    if (error) {
      if (error.required) {
        return 'This field is required';
      } else if (error.minlength) {
        return (
          'Minimum of ' +
          error.minlength.requiredLength +
          ' characters required'
        );
      } else if (error.email) {
        return 'Invalid email address';
      } else if (error.tenDigits) {
        return 'Invalid phone number';
      } else {
        return 'Invalid';
      }
    } else {
      return '';
    }
  }

  // Phone number formatting and validation
  formattedPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const result = this.formatPhoneNoAlpha(control.value);
      const digits = result && result.value ? result.value : '';

      const hasTenDigits = /^\d{10}$/.test(digits);
      return hasTenDigits ? null : { 'tenDigits': { value: control.value } };
    };
  }

  updatePhoneDisplayInForm(formType: string, e?: KeyboardEvent): boolean {
    let formGroup: FormGroup | null = null;

    if (formType === 'contactUsForm') {
      formGroup = this.contactUsForm;
    } else if (formType === 'bidRequestForm') {
      formGroup = this.bidRequestForm;
    } else if (formType === 'careersForm') {
      formGroup = this.careersForm;
    }

    if (!formGroup) {
      return false
    }

    // KA Manager Phone
    const primaryValue = formGroup.get('phone')?.value ?? '';
    const primaryResult = this.formatPhoneNoAlpha(primaryValue, e);
    // Branch User Phone
    // let branchValue = this.accountForm.get('branchUserPhone').value;
    // const branchResult = this.helperService.formatPhoneNoAlpha(branchValue, e);

    if (primaryResult) {
      window.setTimeout(() => {
        formGroup.get('phone')?.setValue(primaryResult.display, { emitEvent: false });
      }, 0);
    }
    // if (branchResult) {
    //   window.setTimeout(() => {
    //     this.accountForm
    //       .get('branchUserPhone')
    //       .setValue(branchResult.display, { emitEvent: false });
    //   }, 0);
    // }

    return true;
  }

  formatPhoneNoAlpha( value: string, e?: KeyboardEvent ): { display: string; value: string } | null {
    // return on non-numeric keys to prevent input
    if (
      e !== undefined &&
      ((e.shiftKey === true && e.keyCode > 47) ||
        (e.keyCode > 57 && e.keyCode < 96) ||
        e.keyCode > 105)
    ) {
      e.preventDefault();
      return null;
    }
    // return when no value
    if (!value) return null;

    var output = '';
    var input = value.replace(/[^0-9]/g, '');

    if (input.length > 6) {
      output =
        '(' +
        input.substring(0, 3) +
        ') ' +
        input.substring(3, 6) +
        '-' +
        input.substring(6);
    } else if (input.length > 3) {
      output = '(' + input.substring(0, 3) + ') ' + input.substring(3);
    } else {
      output = input;
    }

    const retVal = {
      display: output,
      value: output.replace(/[^0-9]/g, ''),
    };

    return retVal;
  }

  private clearFileInput(id: string) {
    const el = document.getElementById(id) as HTMLInputElement | null;
    if (el) el.value = '';
  }

}
